/**
 * @author chandra.shekhar
 * @Date: 2018-10-30 15:44:07
 * @Last Modified by: sai.shiva
 * @Last Modified time: 2022-07-22 16:45:02
 */

const NEWS_ARTICLES = [
  {
    key: 79,
    newsLink: 'https://financialit.net/news/management/zaggle-one-11-bfsis-selected-npci-and-meity-showcase-their-solutions-digital-india',
    newsDate: 'July 06, 2022',
    newsTitle: 'ZAGGLE IS ONE OF THE 11 BFSIS SELECTED BY NPCI AND MEITY TO SHOWCASE THEIR SOLUTIONS AT DIGITAL INDIA WEEK 2022',
    newsDec: 'Zaggle, a profitable SaaS FinTech company and a pioneer in digitizing business spending, has been selected by NPCI and MeitY to showcase its solutions at the 8th edition of Digital India Week 2022 to be hosted in Gandhinagar, Gujarat from 4-8th Jul 2022. Out of 50+ entries, NPCI and MeitY hand-picked Zaggle for its innovative and state-of-the-art solutions.',
  },
  {
    key: 78,
    newsLink: 'https://www.cxotoday.com/press-release/zaggle-is-one-of-the-11-bfsis-selected-by-npci-and-meity-to-showcase-their-solutions-at-digital-india-week-2022/',
    newsDate: 'July 06, 2022',
    newsTitle: 'Zaggle is one of the 11 BFSIs selected by NPCI and MeitY to showcase their solutions at Digital India Week 2022',
    newsDec: 'Zaggle, a profitable SaaS FinTech company and a pioneer in digitizing business spends, has been selected by NPCI and MeitY to showcase its solutions at the 8th edition of Digital India Week 2022 to be hosted in Gandhinagar, Gujarat from 4-8th July, 2022. Out of 50+ entries, NPCI and MeitY hand-picked Zaggle for its innovative and state-of-the-art solutions.',
  },
  {
    key: 77,
    newsLink: 'https://bwdisrupt.businessworld.in/amp/article/Zaggle-Gets-Selected-By-NPCI-MeitY-To-Showcase-Solutions-At-Digital-India-Week-2022-/06-07-2022-435790/',
    newsDate: 'July 06, 2022',
    newsTitle: 'Zaggle Gets Selected By NPCI, MeitY To Showcase Solutions At Digital India Week 2022',
    newsDec: 'Zaggle, a profitable SaaS FinTech company and a pioneer in digitising business spends, has been selected by NPCI and MeitY to showcase its solutions at the 8th edition of Digital India Week 2022 to be hosted in Gandhinagar, Gujarat from 4-8thJuly, 2022. Out of 50+ entries, NPCI and MeitY hand-picked Zaggle for its innovative and state-of-the-art solutions.',
  },
  {
    key: 76,
    newsLink: 'https://www.businessworld.in/article/Zaggle-Gets-Selected-By-NPCI-MeitY-To-Showcase-Solutions-At-Digital-India-Week-2022/06-07-2022-435682/',
    newsDate: 'July 06, 2022',
    newsTitle: 'Zaggle Gets Selected By NPCI, MeitY To Showcase Solutions At Digital India Week 2022',
    newsDec: 'Out of 50+ entries, NPCI and MeitY hand-picked Zaggle for its innovative and state-of-the-art solutions',
  },
  {
    key: 75,
    newsLink: 'https://inc42.com/buzz/intuits-shutting-down-quickbooks-offer-opportunities-to-startups-like-zoho/',
    newsDate: 'July 01, 2022',
    newsTitle: 'Intuit QuickBooks’ India Exit Shows The Challenges In Making For India’s SMEs',
    newsDec: 'After a journey of a decade, software company Intuit will stop offering QuickBooks, its financial and business management software for small businesses, in India from January 31, 2023.',
  },
  {
    key: 74,
    newsLink: 'https://indianexpress.com/article/business/banking-and-finance/rbi-eyes-bnpl-norms-to-rope-in-fintechs-amid-concerns-over-cards-by-non-bank-ppi-issuers-to-extend-short-term-loans-7991632/',
    newsDate: 'June 26, 2022',
    newsTitle: 'RBI eyes BNPL norms, to rope in fintechs amid concerns over cards by non-bank PPI issuers to extend short-term loans',
    newsDec: 'The banking regulator is in discussion with fintech players to find a way out and bring the segment under a regulatory framework so that PPIs are used as a payment instrument and not as a credit avenue.',
  },
  {
    key: 73,
    newsLink: 'https://bwdisrupt.businessworld.in/amp/article/RBI-s-Move-To-Link-Credit-Cards-With-UPI-Expectations-Vs-Reality/22-06-2022-433504/',
    newsDate: 'June 22, 2022',
    newsTitle: 'RBI`s Move To Link Credit Cards With UPI: Expectations Vs Reality',
    newsDec: 'Currently, UPI facilitates transactions by linking savings/current accounts through users’ debit cards. However, since there is no MDR charged to merchants for UPI payments, there is an open question of how will the credit card issuers cover their cost of capital.',
  },
  {
    key: 72,
    newsLink: 'https://bfsi.economictimes.indiatimes.com/news/industry/bold-and-ambitious-vision-document-industry-experts-on-rbis-payments-vision-2025/92338952',
    newsDate: 'June 21, 2022',
    newsTitle: 'Bold and ambitious vision document: Industry experts on RBI`s Payments Vision 2025',
    newsDec: 'Reserve Bank of ’s Payments Vision 2025 is an extremely bold and ambitious vision document, which demonstrates India`s thought leadership in the global payment arena, opined industry leaders.',
  },
  {
    key: 71,
    newsLink: 'https://www.businessinsider.in/finance/news/digital-payments-are-on-track-to-cross-the-200-billion-mark-but-fintechs-are-yet-to-earn-from-them/amp_articleshow/92358010.cms',
    newsDate: 'June 21, 2022',
    newsTitle: 'Digital payments are on track to cross the 200 billion mark, but fintechs are yet to ‘earn’ from them',
    newsDec: 'Digital payments transactions in India are expected to cross the 200 million mark in the next three years, Emkay Research’s recent report has revealed. The Reserve Bank of India’s recently released ‘Payments Vision 2025’ is not only going to boost digital payments in India but make them a strong ecosystem too, the report added.',
  },
  {
    key: 70,
    newsLink: 'https://economictimes.indiatimes.com/tech/technology/rbis-payments-vision-2025-aims-to-establish-india-as-powerhouse-of-payments-globally-say-experts/articleshow/92331886.cms',
    newsDate: 'June 20, 2022',
    newsTitle: 'RBI`s `Payments Vision 2025` aims to establish India as powerhouse of payments globally, say experts',
    newsDec: 'The Reserve Bank`s `Payments Vision 2025` document, which seeks a three-fold jump in the number of digital payments, is progressive and aims to establish India as a powerhouse of payments globally, opined industry players.',
  },
  {
    key: 69,
    newsLink: 'https://www.livemint.com/industry/banking/rbis-payments-vision-2025-aims-to-establish-india-as-powerhouse-of-payments-globally-say-experts-11655633959504.html',
    newsDate: 'June 19, 2022',
    newsTitle: 'RBI aims to establish India as a powerhouse of digital payments globally',
    newsDec: 'The Reserve Bank`s `Payments Vision 2025` document, which seeks a three-fold jump in the number of digital payments, is progressive and aims to establish India as a powerhouse of payments globally, opined industry players.',
  },
  {
    key: 68,
    newsLink: 'https://www.thehansindia.com/business/stakeholders-welcome-rbis-plan-to-introduce-cbdc-749458',
    newsDate: 'June 19, 2022',
    newsTitle: 'Stakeholders welcome RBI`s plan to introduce CBDC',
    newsDec: 'We are in the midst of a technological revolution in the sphere of financial services. Technology and innovation per se are neither destructive nor constructive. It is the use cases that present the responsible or irresponsible sides of any particular innovation or technology.',
  },
  {
    key: 67,
    newsLink: 'https://www.thehindu.com/business/rbis-payments-vision-2025-aims-to-establish-india-as-powerhouse-of-payments-globally-say-experts/article65542561.ece',
    newsDate: 'June 19, 2022',
    newsTitle: 'RBI`s `Payments Vision 2025` aims to establish India as powerhouse of payments globally, say experts',
    newsDec: 'The core theme of the ‘Payments Vision 2025’ is ‘E-Payments for Everyone, Everywhere, Everytime’',
  },
  {
    key: 66,
    newsLink: 'https://www.businesstoday.in/latest/economy/story/rbis-payments-vision-2025-aims-to-establish-india-as-powerhouse-of-payments-globally-experts-338248-2022-06-19',
    newsDate: 'June 19, 2022',
    newsTitle: 'RBI`s `Payments Vision 2025` aims to establish India as powerhouse of payments globally: Experts',
    newsDec: 'The Reserve Bank`s `Payments Vision 2025` document, which seeks a three-fold jump in the number of digital payments, is progressive and aims to establish India as a powerhouse of payments globally, opined industry players.',
  },
  {
    key: 65,
    newsLink: 'https://www.business-standard.com/article/finance/rbi-aims-to-make-india-a-powerhouse-of-payments-globally-by-2025-experts-122061900490_1.html',
    newsDate: 'June 19, 2022',
    newsTitle: 'RBI aims to make India a powerhouse of payments globally by 2025: Experts',
    newsDec: 'The RBI came out with its `Payments Vision 2025` document which also talks about ring-fencing of domestic payment systems, including the need to mandate domestic processing of payment transactions',
  },
  {
    key: 64,
    newsLink: 'https://www.businessworld.in/article/Welcome-To-The-Passwordless-Future/09-06-2022-432067/',
    newsDate: 'June 09, 2022',
    newsTitle: 'Welcome To The Passwordless Future',
    newsDec: 'The world’s greatest companies, including Apple, Google, Microsoft, Meta, Lenovo, Samsung, Visa and many more, are working together as FIDO members to make passwords a thing of past',
  },
  {
    key: 63,
    newsLink: 'https://www.businessworld.in/article/Recession-In-India-A-Myth-Or-Upcoming-Reality/06-06-2022-431298/',
    newsDate: 'June 06, 2022',
    newsTitle: 'Recession In India: A Myth Or Upcoming Reality',
    newsDec: 'India`s growth story had been receiving enthusiasm globally amid constraints like Covid-19, chip shortages, geopolitical conflict, rising commodity prices, container shortages and significant shipping and logistics issues, says Union Minister Piyush Goyal',
  },
  {
    key: 62,
    newsLink: 'https://www.businessworld.in/article/More-VPN-Providers-To-Follow-After-ExpressVPN-s-India-Exit-/04-06-2022-431447/',
    newsDate: 'June 04, 2022',
    newsTitle: 'More VPN Providers To Follow After ExpressVPN’s India Exit?',
    newsDec: 'ExpressVPN`s exit from India has got the debate going on the major shift in data retention laws of the country that has thrown a large shadow on internet privacy',
  },
  {
    key: 61,
    newsLink: 'https://www.fortuneindia.com/long-reads/learning-to-live-with-fintech/108091',
    newsDate: 'May 9, 2022',
    newsTitle: 'Learning to Live with Fintech',
    newsDec: 'It takes two to tango, and banks and fintechs are increasingly realising this. while such tie-ups help the former slash operational costs, for the latter, it promises access to a wider universe.',
  },
  {
    key: 60,
    newsLink: 'https://yourstory.com/2022/04/neobanking-startups-hylobiz-open-zeta-zaggle-karboncard/amp?fbclid=IwAR1-8qoqmuuQxAhtSfA0dK21x8PENb2fVkoF0logLeJAYhn2xg_1MCKWNa4',
    newsDate: 'May 2, 2022',
    newsTitle: 'These neobanking startups are providing entrepreneurs with a seamless and integrated customer experience',
    newsDec: 'By providing a differentiated experience to the end-user, neobanks or online banks have witnessed higher user adoption. YourStory has curated a list of startups working in neobanking that help SMEs automate and run their finances effectively.',
  },
  {
    key: 59,
    newsLink: 'https://yourstory.com/2022/04/product-roadmap-fintech-startup-zaggle-digitises-spending/amp',
    newsDate: 'April 27, 2022',
    newsTitle: '[Product Roadmap] How fintech startup Zaggle digitises spending for organisations and rewards employees',
    newsDec: 'In this week’s Product Roadmap, we feature fintech startup Zaggle, which helps companies achieve scale by winning over and retaining customers. .',
  },
  {
    key: 58,
    newsLink: 'https://www.theweek.in/wire-updates/business/2022/04/18/pwr2-lendit-fintech.amp.html',
    newsDate: 'April 18, 2022',
    newsTitle: 'LendIt Fintech hosts India - The World`s `Fintech Lab` session',
    newsDec: 'India has been at the epicentre of a global `lab testing` environment which has ushered in a new wave of technological advancement leading to the creation of several innovative business models, products and other opportunities in the Fintech space..',
  },
  {
    key: 57,
    newsLink: 'https://bfsi.economictimes.indiatimes.com/videos/banking-has-improved-but-banks-have-not-zaggle-founder-raj-n/90692449',
    newsDate: 'April 07, 2022',
    newsTitle: 'The word `banking` has improved, but banking has not: Zaggle founder Raj N',
    newsDec: 'Raj N, founder and chairman of Zaggle, believes that the banking sector is at a cross-section - either it has to evolve from here or it has to die. "Earlier banks used to invest in FinTechs, but today the scenario is reversed.. and a couple of scenarios have emerged where FinTechs have bought a bank out," Raj said..',
  },
  {
    key: 56,
    newsLink: 'https://www.freepressjournal.in/business/zaggle-partners-with-tata-capitals-moneyfy-platform',
    newsDate: 'April 04, 2022',
    newsTitle: 'Zaggle partners with Tata Capital’s Moneyfy platform',
    newsDec: 'Zaggle, SaaS fintech company announced it has partnered with Tata Capital’s digital wealth management platform – Moneyfy. This will greatly benefit Zaggle users, who can now get easy access to a plethora of investment options available on Moneyfy...',
  },
  {
    key: 55,
    newsLink: 'https://hr.economictimes.indiatimes.com/amp/news/hrtech/talent-acquisition-and-management/how-this-company-tripled-its-employee-strength/90531169',
    newsDate: 'March 30, 2022',
    newsTitle: 'How this company tripled its employee strength',
    newsDec: 'Zaggle, a SaaS FinTech company, has almost tripled its headcount from 120 to 350 over a period of one year. The company is planning to further triple its employee strength this year.',
  },
  {
    key: 54,
    newsLink: 'https://www.livemint.com/companies/news/zaggle-partners-cashe-to-provide-affordable-credit-11647930311668.html',
    newsDate: 'March 22, 2022',
    newsTitle: 'Zaggle partners CASHe to offer affordable, customised credit solutions',
    newsDec: 'Zaggle users can now seamlessly avail a host of new-age, customised credit products from CASHe including personal loans, credit line and BNPL to fulfil their financial needs . .',
  },
  {
    key: 53,
    newsLink: 'https://hr.economictimes.indiatimes.com/news/trends/employee-experience/menopause-at-workplace-break-the-silence-provide-support/90178310',
    newsDate: 'March 13, 2022',
    newsTitle: 'Menopause at workplace: Break the silence, provide support',
    newsDec: 'Menopause impacts women employees, especially those reaching top positions, adversely, but it has got scant attention from organisations',
  },
  {
    key: 52,
    newsLink: 'https://timesofindia.indiatimes.com/business/startups/companies/meet-hyderabads-soonicorns/articleshow/89767697.cms',
    newsDate: 'February 23, 2022',
    newsTitle: 'Meet Hyderabad\'s Soonicorns',
    newsDec: 'Hyderabad seems to be slowly but surely carving out its niche in the SaaS (software as a service) space, which has churned out the most number of unicorns from the city.',
  },
  {
    key: 51,
    newsLink: 'https://hr.economictimes.indiatimes.com/news/industry/zaggle-appoints-paromita-deb-areng-as-chief-human-resource-officer/89661190',
    newsDate: 'February 18, 2022',
    newsTitle: 'Zaggle appoints Paromita Deb Areng as Chief Human Resource Officer',
    newsDec: 'Under Areng’s leadership, Zaggle plans to increase its workforce to 1,000 people by 2023, from its current base of 350 employees.',
  },
  {
    key: 1,
    newsLink: 'https://www.pymnts.com/payments-as-a-service/2022/card-networks-leverage-strategic-investments-to-secure-eu-foothold/',
    newsDate: 'September 16, 2022',
    newsTitle: 'Indian FinTech Zaggle Launches AP, Credit Card Payments Platform',
    newsDec: 'Indian FinTech company Zaggle has reportedly launched a product called Zoyer that brings accounts payable (AP) and credit card payments together on a single platform.',
  },
  {
    key: 50,
    newsLink: 'https://www.ndtv.com/business/budget-2022-digitising-indias-growth-opportunities-2760450',
    newsDate: 'February 10, 2022',
    newsTitle: 'Opinion: How Budget 2022 Is Digitising India\'s Growth Opportunities',
    newsDec: 'Union Budget 2022 has achieved a fine balance between macro-growth and all-inclusive welfare through the establishment of a digital economy and a booming FinTech ecosystem.',
  },
  {
    key: 49,
    newsLink: 'https://hr.economictimes.indiatimes.com/news/industry/zaggle-appoints-sathish-n-as-chief-product-officer/88948183',
    newsDate: 'January 17, 2022,',
    newsTitle: 'Zaggle appoints Sathish N as Chief Product Officer',
    newsDec: 'At Zaggle, Sathish N will work closely with the fintech firm’s MD and CEO, Avinash Godkhindi, and lead product innovation, besides being in charge of the overall product strategy, design and development.',
  },
  {
    key: 48,
    newsLink: 'https://cio.economictimes.indiatimes.com/news/strategy-and-management/digitising-payments-can-save-cfos-precious-hours-raise-productivity/88389875',
    newsDate: 'December 20, 2021',
    newsTitle: 'Digitising payments can save CFOs precious hours, raise productivity',
    newsDec: 'By switching to a digital format, CFOs can seamlessly integrate their accounts payable and accounts receivable processes, eliminating the countless hours wasted with the manual reconciliation of checks and cash transactions. Here is my view.',
  },
  {
    key: 47,
    newsLink: 'https://www.thehindubusinessline.com/companies/zaggle-names-vidyaniwas-as-cfo/article37959231.ece',
    newsDate: 'December 15, 2021',
    newsTitle: 'Zaggle names Vidyaniwas as CFO',
    newsDec: 'Vidyaniwas comes with over 20 years of expertise in private equity, entrepreneurship, corporate development, engineering and business consulting. Zaggle, a fintech company offering software-as-a-service solutions, has appointed Vidyaniwas Khetawat as its Chief Financial Officer',
  },
  {
    key: 46,
    newsLink: 'http://bwdisrupt.businessworld.in/article/Zaggle-Partners-With-EarlySalary/16-11-2021-412114',
    newsDate: 'November 16, 2021',
    newsTitle: 'Zaggle Partners With EarlySalary',
    newsDec: 'This partnership will be beneficial to EarlySalary in terms of extending its financial wellness program by leveraging the large user base of Zaggle especially in the corporate and the enterprise segment.',
  },
  {
    key: 45,
    newsLink: 'https://www.cxooutlook.com/the-importance-of-seamless-cash-flow-management-for-smes/',
    newsDate: 'October 4, 2021',
    newsTitle: 'The Importance of Seamless Cash Flow management for SMEs',
    newsDec: 'Raj is a seasoned professional with over 22 years of experience working in India and the US. He is a serial entrepreneur and has built and sold businesses in areas such as Financial Services, Prepaid Internet Retail, Loyalty, Merchandising, Reward and Recognition, Open Banking, and Expense Management. Raj is also an active Angel Investor and Mentor and has invested in over 25 companies.',
  },
  {
    key: 44,
    newsLink: 'http://bwdisrupt.businessworld.in/article/10-Reasons-Why-Smes-Should-Invest-In-Digital-/09-09-2021-403822/',
    newsDate: 'September 9, 2021',
    newsTitle: '10 Reasons Why SMEs Should Invest In Digital',
    newsDec: 'A significant advantage of digitization is that these features are not restricted only to computers but are also available in a mobile version. That lets the owner have any time and easy access',
  },
  {
    key: 43,
    newsLink: 'https://hr.economictimes.indiatimes.com/news/industry/arundhoti-banerjee-joins-zaggle-as-chief-operating-officer/85857816',
    newsDate: 'September 2, 2021',
    newsTitle: 'Arundhoti Banerjee joins Zaggle as Chief Operating Officer',
    newsDec: 'A graduate of IIM Ahmedabad, Banerjee is a FinTech veteran with more than 15 years of experience. She has built and managed large teams while heading the digital cross-border payments business at Finablr.',
  },
  {
    key: 42,
    newsLink: 'https://ibsintelligence.com/ibsi-news/zaggle-bags-85-new-contracts-worth-4-5-billion/',
    newsDate: 'August 13, 2021',
    newsTitle: 'Zaggle bags 85 new contracts worth 4.5 billion',
    newsDec: 'FinTech Company Zaggle has announced today that they have successfully bagged 85 new contracts in the first quarter of FY2021-2022.',
  },
  {
    key: 41,
    newsLink: 'https://thetechpanda.com/startup-watch-zaggle-cost-effective-fintech-tools-to-help-smes-conduct-transparent-business-processes/33838/',
    newsDate: 'July 2, 2021',
    newsTitle: '{Startup watch: Zaggle} Cost-effective fintech tools to help SMEs conduct transparent business processes',
    newsDec: 'This B2B fintech company provides SaaS solutions for businesses and Small and Medium Enterprises (SMEs). Today’s SMEs are not only looking for technological efficiency, but also cost-effective ways to manage their activities. SMEs especially hate the idea of integrating technology into business processes when evaluating it from a cost perspective. This is where companies like Zaggle come in.',
  },
  {
    key: 40,
    newsLink: 'https://hr.economictimes.indiatimes.com/news/trends/zaggle-organizes-vaccination-drives-for-its-employees-and-startup/83359347',
    newsDate: 'June 9, 2021',
    newsTitle: 'Zaggle organizes vaccination drives for its employees and startup',
    newsDec: 'Zaggle, launched a vaccination initiative for its employees and other startups to lend them a helping hand in these trying times.The drive is going on in the HiTechCity of Hyderabad and is also ready to take off in Mumbai within the span of a few weeks.',
  },
  {
    key: 39,
    newsLink: 'https://thetechpanda.com/fintech-must-pull-up-its-socks-in-the-face-of-cyber-threats-imminent-data-breaches/33233/',
    newsDate: 'May 19, 2021',
    newsTitle: 'Fintech must pull up its socks in the face of cyber threats & imminent data breaches',
    newsDec: 'Fintech being one of the most vulnerable of sectors in the face of new-fangled cyber threats resulting in costly data breaches, fintech organizations must stay ahead in cybersecurity practices.',
  },
  {
    key: 38,
    newsLink: 'https://thefintechtimes.com/spotlight-asia-the-evolution-of-neobanks-and-growth-of-new-technologies-part-2/',
    newsDate: 'April 27, 2021',
    newsTitle: 'Spotlight Asia: Neobanks and Growth of New Technologies Part Two',
    newsDec: 'Throughout April 2021, The Fintech Times shines a light on neobanks and challenger banks, including their evolution and successes. With digital banks a hot talking point, in this two-part feature we hear from some of the major players in Asia, including Revolut, Wise, WeLab Bank, Zaggle, Aspire and Tonik.',
  },
  {
    key: 37,
    newsLink: 'https://www.outlookindia.com/outlookmoney/tax/digitisation-a-win-win-for-employees-employers-6462',
    newsDate: 'March 17, 2021',
    newsTitle: 'Digitisation A Win-Win For Employees & Employers',
    newsDec: 'By embracing digitisation, companies have been able to solve complicated problems associated with routine tasks. . . .',
  },
  {
    key: 36,
    newsLink: 'https://thetechpanda.com/ai-in-banking-can-banks-meet-the-challenge/32557/',
    newsDate: 'March 3, 2021',
    newsTitle: 'AI in Banking: Can Banks Meet the Challenge?',
    newsDec: 'Technology is improving the overall quality of our lives and increasing the pace of progress that we register in every sphere. Artificial Intelligence (AI) is a new tech buzzword.',
  },
  {
    key: 35,
    newsLink: 'https://www.fintechfutures.com/2021/03/indian-start-up-zaggle-registers-new-fintech-zik-zuk-to-offer-smes-credit/',
    newsDate: 'March 2, 2021',
    newsTitle: 'Indian start-up Zaggle registers new fintech ZikZuk to offer SMEs credit',
    newsDec: 'Zaggle, a 2011-founded Software-as-a-Service (SaaS) fintech based out of Mumbai, has registered a new fintech start-up called “ZikZuk”.',
  },
  {
    key: 34,
    newsLink: 'https://menafn.com/1101631783/Zaggle-Wins-the-Best-Employee-Engagement-Award-in-The-B2B-Segment-at-the-29th-Edition-of-World-HRD-Congress-Awards-2021',
    newsDate: 'February 20, 2021',
    newsTitle: 'Zaggle Wins the Best Employee Engagement Award in The B2B Segment at the 29th Edition of World HRD Congress & Awards 2021',
    newsDec: 'Zaggle, a leading award winning FinTech company was conferred with the Best Employee Engagement Award in the B2B segment in the Employee Engagement Leadership Awards Category at the 29th edition of World HRD Congress & Awards 2021.',
  },
  {
    key: 33,
    newsLink: 'https://www.business-standard.com/article/technology/sold-t-shirts-at-16-cutting-edge-digital-spending-solutions-provider-today-121011200616_1.html',
    newsDate: 'January 12, 2021',
    newsTitle: 'Sold t-shirts at 16, cutting-edge digital spending solutions provider today',
    newsDec: 'Way back in 1987, sixteen-year-old Raj Narayanam took up odd jobs in order to pay for a pair Nike Shoes he wanted. He managed to save about Rs 1,200 from his salary, and approached his father for the balance.',
  },
  {
    key: 32,
    newsLink: 'https://www.financialexpress.com/industry/fintech-in-2021-how-fintech-will-evolve-over-3-5-years/2158524/',
    newsDate: 'December 28, 2020',
    newsTitle: 'Fintech in 2021: How fintech will evolve over 3-5 years',
    newsDec: 'The Covid-19 pandemic has changed the whole scenario for the fintech industry. Technology has been the foundation for the growth of fintech in India.',
  },
  {
    key: 31,
    newsLink: 'https://www.pninews.com/raj-n-among-the-most-promising-business-leaders-of-asia/',
    newsDate: 'December 16, 2020',
    newsTitle: 'Raj N among the ‘Most Promising Business Leaders of Asia',
    newsDec: 'Mr. Raj N, the Founder and Chairman of leading FinTech company, Zaggle has been named among the “Most Promising Business Leaders of Asia” at The Economic Times ‘Asian Business Leaders Conclave 2020’.',
  },
  {
    key: 30,
    newsLink: 'https://indianshowbiz.wordpress.com/2020/12/16/zaggle-promoter-raj-n-among-the-most-promising-business-leaders-of-asia-released-at-the-economic-times-asian-business-leaders-conclave-2020/',
    newsDate: 'December 16, 2020',
    newsTitle: 'Zaggle promoter Raj N among the ‘Most Promising Business Leaders of Asia’ released at The Economic Times Asian Business Leaders Conclave 2020',
    newsDec: 'Mr. Raj N, the Founder and Chairman of leading FinTech company, Zaggle has been named among the “Most Promising Business Leaders of Asia” at The Economic Times ‘Asian Business Leaders Conclave 2020’.',
  },
  {
    key: 29,
    newsLink: 'https://menafn.com/1101288744/Zaggle-promoter-Raj-N-among-the-Most-Promising-Business-Leaders-of-Asia-released-at-The-Economic-Times-Asian-Business-Leaders-Conclave-2020',
    newsDate: 'December 16, 2020',
    newsTitle: 'Zaggle promoter Raj N among the ‘Most Promising Business Leaders of Asia’ released at The Economic Times Asian Business Leaders Conclave 2020',
    newsDec: 'Mr. Raj N, the Founder and Chairman of leading FinTech company, Zaggle has been named among the “Most Promising Business Leaders of Asia” at The Economic Times ‘Asian Business Leaders Conclave 2020’.',
  },
  {
    key: 28,
    newsLink: 'https://menafn.com/1101184823/Zaggle-wins-the-best-Fintech-Corporate-Innovation-Program-award-at-The-ETBFSI-Innovation-Tribe-Awards',
    newsDate: 'November 25, 2020',
    newsTitle: 'Zaggle wins the best Fintech Corporate Innovation Program award at The ETBFSI Innovation Tribe Awards',
    newsDec: 'Zaggle Prepaid Ocean Services was conferred the best Fintech Corporate Innovation Program award at The Economic Times BFSI Innovation Tribe Awards 2020.',
  },
  {
    key: 27,
    newsLink: 'https://economictimes.indiatimes.com/magazines/panache/wfh-woes-zaggle-chairmans-daily-screen-time-went-up-from-6-to-10-hours-during-lockdown/articleshow/79314666.cms',
    newsDate: 'November 21, 2020',
    newsTitle: 'WFH woes: Zaggle Chairman\'s daily screen-time went up from 6 to 10 hours during lockdown',
    newsDec: 'The two gadgets that I can’t live without are my Fitbit smartwatch and smartphone. The smartwatch tracks my physical activity and how the body is responding to it. My phone contains a lot of my information and data required on a day-today basis.',
  },
  {
    key: 26,
    newsLink: 'https://www.fintechfutures.com/2020/06/indian-sme-fintech-zaggle-partners-with-visa-to-launch-founders-card/',
    newsDate: 'June 10, 2020',
    newsTitle: 'Indian SME fintech Zaggle partners with Visa to launch ‘Founders Card’',
    newsDec: 'Zaggle, a fintech start-up based in Hyderabad, India, which offers businesses prepaid cards, expense management and software-as-a-service (SaaS) applications, has landed a partnership with Visa, Economic Times reports.',
  },
  {
    key: 25,
    newsLink: 'https://www.financialexpress.com/money/covid-imapct-reimbursements-as-a-category-will-undergo-a-change/1969492/',
    newsDate: 'May 25, 2020',
    newsTitle: 'Reimbursement part of salary to change! Wi-Fi, BYOD, home office furniture allowance may be new normal',
    newsDec: 'Raj N, the founder of Zaggle, a payments start-up, says pay structure realignment is happening in corporate India as a response to Covid-19',
  },
  {
    key: 24,
    newsLink: 'https://www.business-standard.com/article/pti-stories/fintech-startup-zaggle-ties-up-with-visa-for-innovative-paymentssolutions-for-smes-120052300687_1.html',
    newsDate: 'May 23, 2020',
    newsTitle: 'Fintech startup Zaggle ties up with Visa for innovative paymentssolutions for SMEs',
    newsDec: 'Fintech startup Zaggle on Saturday said it has partnered with payments technology major Visa to launch innovative payment solutions for SMEs and startups.',
  },
  {
    key: 23,
    newsLink: 'https://economictimes.indiatimes.com/small-biz/startups/newsbuzz/fintech-startup-zaggle-joins-hands-with-visa-to-launch-payment-solutions-for-smes-startups/articleshow/75917620.cms',
    newsDate: 'May 23, 2020',
    newsTitle: 'Fintech startup Zaggle joins hands with Visa to launch payment solutions for SMEs, startups',
    newsDec: 'Fintech startup, Zaggle, has announced a partnership with Visa to launch innovative payment solutions for SMEs and startups.',
  },
  {
    key: 22,
    newsLink: 'https://www.thehindu.com/business/zaggle-visa-tie-up-for-sme-payments/article31660334.ece',
    newsDate: 'May 23, 2020',
    newsTitle: 'Zaggle, Visa tie up for SME payments',
    newsDec: 'Zaggle, a financial technology start-up, has announced a partnership with Visa to launch payment solutions for SMEs and start-ups.',
  },
  {
    key: 21,
    newsLink: 'https://www.newindianexpress.com/lifestyle/health/2020/may/08/i-want-to-see-a-better-me-post-covid-19-zaggle-founder-raj-n-phani-2140658.html',
    newsDate: 'May 08, 2020',
    newsTitle: 'I want to see a better me post COVID-19: Zaggle founder Raj N',
    newsDec: 'COVID-19 took everyone by surprise. No one had the time to think as to what needs to be done or how it should be done in such a situation.',
  },
  {
    key: 20,
    newsLink: 'https://www.businesstoday.in/bt-buzz/news/bt-buzz-mukesh-ambani-mark-zuckerberg-and-the-700-billion-kirana-puzzle/story/401746.html',
    newsDate: 'April 22, 2020',
    newsTitle: 'BT Buzz: Mukesh Ambani, Mark Zuckerberg and the $700 billion kirana puzzle',
    newsDec: '"RIL now could leverage WhatsApp\'s userbase and increase its platform\'s reach to digitise the kirana stores and their supply chain to potentially go far beyond other players like Paytm," says, Avinash Godkhindi, MD at fintech firm Zaggle.',
  },
  {
    key: 19,
    newsLink: 'https://bfsi.economictimes.indiatimes.com/news/fintech/covid-19-is-a-turning-point-for-this-fintech/74861775',
    newsDate: 'March 28, 2020',
    newsTitle: 'Covid-19 is a turning point for this FinTech',
    newsDec: 'While most Fintechs are grappling with the shocks of coronavirus pandemic and trying new ways to absorb them, Zaggle, a prepaid card services firm, has found its sweet spot in this unprecedented virus outbreak.',
  },
  {
    key: 18,
    newsLink: 'https://www.ciol.com/soldiering-corona-crisis-whats-keeping-cios-busy/',
    newsDate: 'March 26, 2020',
    newsTitle: 'Soldiering on in the Corona Crisis – What’s Keeping CIOs Busy',
    newsDec: 'Siva Kumar, Chief Technology Officer, Zaggle tells that – Keeping employees safe and reassured is our foremost concern right now.',
  },
  {
    key: 17,
    newsLink: 'https://www.cxotoday.com/press-release/leading-fintech-firm-zaggle-appoints-siva-kumar-as-new-cto/',
    newsDate: 'March 24, 2020',
    newsTitle: 'Leading FinTech firm Zaggle appoints Siva Kumar as New CTO',
    newsDec: 'Leading FinTech startup Zaggle has recently announced the appointment of Siva Kumar as their new Chief Technology Officer. Siva Kumar will be based out of Hyderabad and will head the Technology reporting directly to Founder, Raj N.',
  },
  {
    key: 16,
    newsLink: 'https://bfsi.economictimes.indiatimes.com/news/banking/yes-bank-impact-restaurants-ola-uber-drivers-say-no-to-upi-and-digital-payments/74572317',
    newsDate: 'March 11, 2020',
    newsTitle: 'Yes Bank impact: Restaurants, Ola, Uber drivers say no to UPI and digital payments',
    newsDec: 'Yes Bank’s troubles are not only giving a tough time to its depositors but also restaurants and ride-hailing service companies.',
  },
  {
    key: 15,
    newsLink: 'https://www.firstpost.com/business/budget-2020-startups-expect-slew-of-sops-from-tax-cuts-to-simplification-of-gst-filing-systems-from-finance-minister-7983471.html',
    newsDate: 'February 01, 2020',
    newsTitle: 'Budget 2020: Startups expect slew of sops from tax cuts to simplification of GST filing systems from finance minister',
    newsDec: 'We hope to Budget 2020 focusses more on the startup sector and on creating a conducive environment for their growth. The first five years after company incorporation should be made tax free for startups.',
  },
  {
    key: 14,
    newsLink: 'https://www.deccanchronicle.com/lifestyle/viral-and-trending/211219/spreading-the-festive-cheer.html',
    newsDate: 'December 21, 2019',
    newsTitle: 'Spreading the festive cheer',
    newsDec: 'At workplaces across the city, employees are going about furtively, carrying mysterious parcels, while others are on high alert.',
  },
  {
    key: 13,
    newsLink: 'https://telanganatoday.com/made-in-hyderabad-a-must-read-for-aspiring-entrepreneurs',
    newsDate: 'July 28, 2019',
    newsTitle: 'Made in Hyderabad: A must read for aspiring entrepreneurs',
    newsDec: 'The book Made in Hyderabad, published by Raj N, brings together success stories of city entrepreneurs',
  },
  {
    key: 12,
    newsLink: 'https://www.entrepreneur.com/article/328495',
    newsDate: 'February 19, 2019',
    newsTitle: '15 Hottest Start-ups from Hyderabad to Watch Out For',
    newsDec: 'Launched in 2011, Zaggle is a payments company focusing on Groups. It connects consumer and corporate spends to merchants through proprietary tech platforms.',
  },
  {
    key: 11,
    newsLink: 'https://www.thehindubusinessline.com/news/zaggle-launches-expense-management-solution/article26006382.ece',
    newsDate: 'January 16, 2019',
    newsTitle: 'Zaggle launches expense management solution',
    newsDec: 'Zaggle, a solution provider for digital payments, has launched its Expense Management Solution.',
  },
  {
    key: 10,
    newsLink: 'https://timesofindia.indiatimes.com/business/india-business/zaggle-launches-expense-management-solution/articleshow/67559086.cms',
    newsDate: 'January 16, 2019',
    newsTitle: 'Zaggle launches expense management solution',
    newsDec: 'City-based digital payments, employee benefits rewards & recognition, loyalty, and gift cards solutions provider Zaggle on Wednesday announced the launch of its expense management solution that allows enterprises to manage their entire expense process and manage cash flows using data analytics, thus, eliminating cases of fraudulent spends and cumbersome paperwork.',
  },
  {
    key: 9,
    newsLink: 'https://www.apnnews.com/zaggle-announces-corporate-partnership-with-ketan-diamonds/',
    newsDate: 'Oct 05, 2018',
    newsTitle: 'Zaggle announces corporate partnership with Ketan Diamonds',
    newsDec: 'Hyderabad-based digital payments and group dining deals company, Zaggle, has partnered with Ketan Diamonds, a new entrant in the online diamond jewellery market in the country.',
  },
  {
    key: 8,
    newsLink: 'http://www.thehansindia.com/posts/index/Business/2018-10-05/Zaggle-partners-with-Ketan-Diamonds/419249',
    newsDate: 'Oct 05, 2018',
    newsTitle: 'Zaggle partners with Ketan Diamonds',
    newsDec: 'Zaggle, a city-based digital payments and group dining deals company, on Thursday announced a partnership with Ketan Diamonds, an online diamond jewellery market.',
  },
  {
    key: 7,
    newsLink: 'https://yourstory.com/2018/08/zaggle-grew-revenues-6x-rs-650-crore-just-year?fbclid=IwAR1KeCLsygBSCWR6lbjyIvAJO8l-vJ_ixVeWKV_cC5iPBPf3M4fxc1sJR2Y',
    newsDate: 'Aug 22, 2018',
    newsTitle: 'How Zaggle grew its revenues 6x to Rs 650 crore in just a year',
    newsDec: 'Zaggle pivoted from being a gift card provider to a digital payments, cashback and analytics company, and is helping companies and retailers score big on customer loyalty.',
  },
  {
    key: 6,
    newsLink: 'https://www.vccircle.com/enterprise-cashback-firm-zaggle-buys-payments-company-click-pay/',
    newsDate: 'July 17, 2018',
    newsTitle: 'Enterprise cashback firm Zaggle buys payments company Click&pay',
    newsDec: 'Hyderabad-based digital payments and cashback company Zaggle has acquired mobile-based payments firm Click & Pay in a cash-and-stock deal, the company said in a statement',
  },
  {
    key: 5,
    newsLink: 'https://www.indiatoday.in/pti-feed/story/total-sets-up-digital-innovation-centre-in-india-with-tcs-1288538-2018-07-17',
    newsDate: 'July 17, 2018',
    newsTitle: 'Total sets up digital innovation centre in India with TCS',
    newsDec: 'New Delhi, July 17 (PTI) Indias largest IT services firm TCS today said it has signed a partnership agreement with Total, a global integrated energy producer and provider, to create a digital innovation centre in India.',
  },
  {
    key: 4,
    newsLink: 'https://www.thehindubusinessline.com/companies/zaggle-acquires-hyderabad-based-clickpay/article24441726.ece',
    newsDate: 'July 17, 2018',
    newsTitle: 'Zaggle acquires Hyderabad-based Click&Pay',
    newsDec: 'Zaggle, a payments and group dining company, has acquired Hyderabad-based Click&Pay, a tech start-up backed by Dubai-based investors, in a cash-and-stock deal.',
  },
  {
    key: 3,
    newsLink: 'https://telanganatoday.com/hyderabads-zaggle-aims-1-billion-firm',
    newsDate: 'April 11, 2018',
    newsTitle: 'Hyderabad’s Zaggle aims to be $1 billion firm',
    newsDec: 'Even companies like Sodexo and Vantage Circle have not been able to solve this problem fully. To provide a hassle-free platform for corporates to manage their expenses and at the same time provide required benefits to employees seamlessly, Raj N started Zaggle.',
  },
  {
    key: 2,
    newsLink: 'https://www.thehindubusinessline.com/companies/zaggle-announces-hardik-pandya-as-brand-ambassador/article22762052.ece',
    newsDate: 'February 15, 2018',
    newsTitle: 'Zaggle announces Hardik Pandya as brand ambassador',
    newsDec: 'Zaggle, a payments and group-dining company, has announced cricketer Hardik Pandya as its brand ambassador.',
  },
  {
    key: 1,
    newsLink: 'https://indianceo.in/startup/hyderabad-startup-zaggle-acquires-bangalore-based-startup-pennyful/',
    newsDate: 'April 12, 2017',
    newsTitle: 'Hyderabad Startup Zaggle acquires Bangalore-based Startup Pennyful',
    newsDec: 'Online digital payment startup from Hyderabad Zaggle has acquired Bangalore-Based online coupons firm Pennyful in a cash-and-stock deal. However, the financial details of the deal were undisclosed.',
  },
  {
    key: 0,
    newsLink: 'https://economictimes.indiatimes.com/small-biz/startups/cashback-company-zaggle-buys-pennyful/articleshow/58101909.cms',
    newsDate: 'April 10, 2017',
    newsTitle: 'Cashback company Zaggle buys Pennyful',
    newsDec: 'Cashback and analytics company Zaggle Prepaid Ocean Services, which offers cashbacks to customers at restaurants, has acquired Bengaluru-based online cashback and coupons company Pennyful in a cash-and-stock deal.',
  },
];

export { NEWS_ARTICLES };



// WEBPACK FOOTER //
// client/containers/Press/constants.js